export const messagesEn = {
  'welcome.eyebrow': 'Getting Started',
  'welcome.greeting.fallback': 'Welcome to Kontora!',
  'welcome.greeting.named': 'Hello {name}!',
  'welcome.description':
    "Kontora is organised into six areas. Pick a context below – we'll show you only what's relevant for your current role.",
  'welcome.areas.count': 'Available areas ({count})',
  'welcome.tours.completed': '{count} tour(s) already completed.',
  'welcome.button.experienced': "I know my way around – hide tours",
  'welcome.button.later': 'Later',
  'welcome.close': 'Close',

  'runner.step.counter': 'Step {current} of {total}',
  'runner.progress.label': 'Workflow progress',
  'runner.summary.heading': 'Previous answers',
  'runner.button.cancel': 'Cancel',
  'runner.button.skip': 'Continue manually',
  'runner.button.back': '← Back',
  'runner.button.confirm': "Let's go →",
  'runner.confirm.hint': "You'll be redirected to the target page.",

  'empty.eyebrow': 'Nothing here yet',

  'widget.title': 'First Steps',
  'widget.subtitle': 'The most important actions to get you started.',

  'banner.power.title': 'Power Mode active',
  'banner.power.description':
    'In Power Mode, all areas are shown regardless of your role.',

  'profile.page.title': 'My profile',
  'profile.page.description':
    'Edit your personal details and notification settings.',
  'profile.displayName': 'Display name',
  'profile.email': 'Email',
  'profile.firstName': 'First name',
  'profile.lastName': 'Last name',
  'profile.phone': 'Phone',
  'profile.phone.placeholder': '+49 30 1234567',
  'profile.timezone': 'Time zone',
  'profile.bio': 'About me',
  'profile.bio.hint': 'Shown in comments and reviews.',
  'profile.bio.placeholder': 'Short description of your role in the company…',
  'profile.notifications': 'Notifications',
  'profile.productUpdates': 'Receive product updates by email',
  'profile.securityAlerts':
    'Receive security alerts (new device login, password change)',
  'profile.unassigned': 'Unnamed',
  'profile.validation.fixErrors': 'Please fix all errors',
  'profile.saved': 'Profile saved',
  'profile.saveError': 'Error while saving',
  'profile.save': 'Save profile',
  'profile.saving': 'Saving…',

  'success.title': 'Success',
  'loading.default.title': 'Loading data',
  'loading.default.aria': 'Loading',
  'error.default.title': 'Something went wrong',
  'error.default.retry': 'Try again',
  'error.default.hint':
    'Please try again. If the problem persists, contact support and share the request ID.',
  'error.default.requestId': 'Request ID',
} as const;

export type MessageKey = keyof typeof messagesEn;